/* tslint:disable */
/* eslint-disable */
export enum WorkCalculationitemTypeEnum {
  Standard = 'standard',
  Discount = 'discount'
}
